import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import * as WrcCommon from '@webrcade/app-common'
import { Global } from '../Global';

// 🔹 i18n
import { useI18n } from '../i18n/I18nContext';

function MainAppBar(props) {
  const { t } = useI18n();

  const StyledAppBar = styled(AppBar)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1
  }));

  return (
    <StyledAppBar position="fixed">
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={Global.toggleDrawer}
          sx={{ mr: 2, display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        <Avatar
          sx={{ mr: 1.3, width: 32, height: 32 }}
          variant="square"
          src={WrcCommon.WebrcadeLogoDarkImage}
        />

        <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
          {/* Antes: Meu Retrô Box Feed Editor */}
          {t('mainAppBarTitle')}
        </Typography>

        <Tooltip title={t('mainAppBarSettings')}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => { Global.openSettingsEditor(true); }}
            sx={{ ml: 2 }}
          >
            <SettingsIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title={t('mainAppBarHelp')}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={() => { window.open('https://docs.webrcade.com/editor/'); }}
            sx={{ ml: .5 }}
          >
            <HelpCenterIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </StyledAppBar>
  );
}

export default MainAppBar;